export default __webpack_public_path__ + "static/Денежный поток 12-9bc8d7bc790573255727075755815e51.jpg";